
<%
let okIco = '<svg class="SvgIco SvgIco-checkBold" width="12" height="9" xmlns="http://www.w3.org/2000/svg">
			<path class="SvgIco_path" d="M10.071 0l1.768 1.767-7.071 7.071L3 7.07z"></path>
			<path class="SvgIco_path" d="M.491 4.509L2.26 2.74l3.567 3.567L4.06 8.076z"></path>
		</svg>';
let crossIco = '<svg class="SvgIco SvgIco-crossBold" width="10" height="10" xmlns="http://www.w3.org/2000/svg"><path class="SvgIco_line" stroke-width="2" d="M1 9l8-8M1 1l8 8"></path></svg>'
%>
<% _.forEach(flats, function(flt, index) { %>
	<% _.forEach(promos, function(promo, indexPromo) { %>
		<% if ( promo && (index + offset) == (promo.order - 1)) { %>
			<div class="Tbl_tr Tbl_tr-link Tbl_tr-promoCard" href="<%= flt.url %>">
				<div class="Tbl_td Tbl_td-promoCardTitle">
					<%= promo.title %>
				</div>
				<div class="Tbl_td Tbl_td-promoCardText">
					<span><%= promo.text %></span>
				</div>
				<div style="display: none;" class="Tbl_td">
				</div>
				<div class="Tbl_td hidden-xs">
				</div>
				<div class="Tbl_td hidden-xs hidden-sm">
				</div>
				<div class="Tbl_td hidden-xs hidden-sm">
				</div>
				<div class="Tbl_td hidden-xs hidden-sm">
				</div>
				<div class="Tbl_td"> </div>
				<div class="Tbl_td">
					<a class="MoreBtn" href="<%= promo.url %>">Подробнее</a>
				</div>
			</div>
		<% } %>
	<% }); %>

<a href="<%= flt.url %>" class="Tbl_tr Tbl_tr-link <% if(flt.special){%> Tbl_tr-promo <% }; %>">
	<div class="Tbl_td Tbl_td-scheme Tbl_td-promo hidden-xs" data-thumb='{"img": "<%= flt.pic %>"}'>
		<img src="<%= flt.pic %>" />
	</div>
	<div class="Tbl_td Tbl_td-promo">
		<%= flt.num %>
		<div class="Tbl_position">
			<% if(flt.special){ %>
			 	<span> <%= flt.special %> </span>
			 <% } %>
		</div>
	</div>
	<div class="Tbl_td Tbl_td-promo">
		<%= flt.floor %>
		<div class="Tbl_position hidden-smPlus"></div>
	</div>
	<div class="Tbl_td hidden-xs hidden-sm"><%= flt.section %></div>
	<div class="Tbl_td"><%= flt.rooms %></div>
	<div class="Tbl_td hidden-xs hidden-sm"><%= flt.area %> м<sup>2</sup></div>
	<div class="Tbl_td hidden-xs hidden-sm">
		<% if(flt.furnish){ %>
			<%= okIco %>
		<% }else{ %>
			<%= crossIco %>
		<% }; %>
	</div>

	<% if(flt.oldPrice){ %>
		<div class="Tbl_td Tbl_td-nowrap">
			<del class="Tbl_delText"><%= flt.oldPrice.toLocaleString("ru-RU") %> ₽</del>
			<br>
			<ins class="Tbl_insText"><%= flt.price.toLocaleString("ru-RU") %> ₽</ins>
		</div>
	<% }else{ %>
		<div class="Tbl_td Tbl_td-nowrap"><%= flt.price.toLocaleString("ru-RU") %> ₽</div>
	<% }; %>
	
	<div style="display: none;" class="Tbl_td _btns">
	    <a class="Tbl_url" href="<%= flt.url %>"></a>
	    <a class="Btn _onlineBuy" data-fancybox href="#Callback">
	        Купить онлайн
	        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.83592 10.6667H15.3634C15.5993 10.6667 15.8063 10.5089 15.8701 10.2798L17.9796 2.81303C18.0249 2.65206 17.9939 2.47915 17.8941 2.3454C17.7941 2.21206 17.6386 2.13331 17.4727 2.13331H4.6185L4.24154 0.417774C4.18798 0.173471 3.97374 0 3.72655 0H0.527342C0.235931 0 0 0.238609 0 0.533329C0 0.828187 0.235931 1.06666 0.527342 1.06666H3.30331L5.20764 9.73325C4.64734 9.97964 4.25389 10.5437 4.25389 11.2C4.25389 12.0823 4.96361 12.8 5.83592 12.8H15.3634C15.6549 12.8 15.8907 12.5616 15.8907 12.2667C15.8907 11.972 15.6549 11.7334 15.3634 11.7334H5.83592C5.54547 11.7334 5.30858 11.4943 5.30858 11.2C5.30858 10.9057 5.54547 10.6667 5.83592 10.6667Z" fill="#946947"/>
                <path d="M5.3092 14.4003C5.3092 15.2826 6.01892 16.0003 6.89137 16.0003C7.76368 16.0003 8.4734 15.2826 8.4734 14.4003C8.4734 13.5181 7.76368 12.8003 6.89137 12.8003C6.01892 12.8003 5.3092 13.5181 5.3092 14.4003Z" fill="#946947"/>
                <path d="M12.726 14.4003C12.726 15.2826 13.4357 16.0003 14.308 16.0003C15.1804 16.0003 15.89 15.2826 15.89 14.4003C15.89 13.5181 15.1804 12.8003 14.308 12.8003C13.4357 12.8003 12.726 13.5181 12.726 14.4003Z" fill="#946947"/>
            </svg>
	    </a>
	</div>

</a>
<% }); %>
